"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorage = void 0;
var memoryCache = new Map();
var LocalStorage = /** @class */ (function () {
    function LocalStorage(config) {
        this.config = config;
    }
    LocalStorage.prototype.setItem = function (key, value) {
        if (!(value == null || value.length === 0)) {
            window.localStorage.setItem(key, value);
            return window.localStorage.getItem(key);
        }
        return null;
    };
    LocalStorage.prototype.getItem = function (key) {
        return window.localStorage.getItem(key);
    };
    LocalStorage.prototype.removeItem = function (key) {
        if (this.getItem(key)) {
            window.localStorage.removeItem(key);
            return true;
        }
        else {
            return false;
        }
    };
    LocalStorage.prototype.clear = function () {
        memoryCache = new Map();
        return {};
    };
    return LocalStorage;
}());
exports.LocalStorage = LocalStorage;
//# sourceMappingURL=local.storage.js.map